import UserStore from '@/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {    
  const userStore = UserStore()
  const { currentUser } = storeToRefs(userStore)

  if (currentUser.value) {
    if (to.name === 'event-slug') {
      return { name: 'app-events-slug', params: to.params }
    }
      
    return { name: 'app' }
  }
})